// extracted by mini-css-extract-plugin
export var background = "_6i-0";
export var container = "_6i-1";
export var contentItem = "_6i-7";
export var extendedWarranty = "_6i-5";
export var link = "_6i-d";
export var modal = "_6i-b";
export var modalCloseButton = "_6i-9";
export var modalContent = "_6i-3";
export var modalContentMain = "_6i-6";
export var modalImageLogo = "_6i-8";
export var modalLogo = "_6i-a";
export var modalSideImage = "_6i-4";
export var preview = "_6i-c";
export var redoModal = "_6i-2";